import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CallLog = ({ show, handleClose, handleSubmit, onSubmit, register, errors, selectedStatus, handleCallLog, reset , today}) => {

    useEffect(() => {
        if (!show) {
            reset();
        }
    }, [show, reset]);

    return (
        
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Log a call</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <select
                            className="form-select"
                            {...register('status', { required: 'Status is required' })}
                            onChange={handleCallLog}
                        >
                            <option value="">-- Select Call Status --</option>
                            <option value="connected">Connected</option>
                            <option value="disconnected">Disconnected</option>
                            <option value="not_reachable">Not Reachable</option>
                            <option value="invalid_no">Invalid No</option>
                        </select>
                        {errors.status && <p className="text-danger">{errors.status.message}</p>}
                    </div>

                    {selectedStatus === 'connected' || selectedStatus === 'disconnected' ? (
                        <>
                            <div className="form-group">
                                <label htmlFor="rescheduleDate" className="form-label">Reschedule Date & Time</label>
                                <input
                                    type="date"
                                    id="rescheduleDate"
                                    {...register('date', { required: 'Date is required' })}
                                    className={`form-control mb-2 ${errors.date ? 'is-invalid' : ''}`}
                                    min={today}
                                />
                                {errors.date && <p className="text-danger">{errors.date.message}</p>}
                            </div>

                            <div className="form-group mt-3">
                                <textarea
                                    className="form-control"
                                    id="callRemark"
                                    rows="2"
                                    placeholder="Call Remark"
                                    {...register('remarks', { required: 'Remark is required' })}
                                ></textarea>
                                {errors.remarks && <p className="text-danger">{errors.remarks.message}</p>}
                            </div>

                            {selectedStatus === 'connected' && (
                                <div className="form-group mt-3">
                                    <select
                                        className="form-select"
                                        {...register('feedback_type', { required: 'Feedback type is required' })}
                                    >
                                        <option value="">Select Feedback Type</option>
                                        <option value="positive">Positive</option>
                                        <option value="negative">Negative</option>
                                    </select>
                                    {errors.feedback_type && <p className="text-danger">{errors.feedback_type.message}</p>}
                                </div>
                            )}

                            <div className="form-group mt-3">
                                <select
                                    className="form-select"
                                    {...register('response', { required: 'Response type is required' })}
                                >
                                    <option value="">Select Response Type</option>
                                    <option value="interested">Interested</option>
                                    <option value="not_interested">Not Interested</option>
                                    <option value="price_issue">Price Issue</option>
                                    <option value="compliance_issue">Compliance Issue</option>
                                </select>
                                {errors.response && <p className="text-danger ">{errors.response.message}</p>}
                            </div>
                        </>
                    ) : null}

                    <div className="modal-footer">
                        <Button variant="danger" size="sm" onClick={handleClose}>Cancel</Button>
                        <Button type="submit" variant="primary" size="sm">Save</Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default CallLog;